import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const editCertificate = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.ORGANIZE.POST_CERTIFICATE,
    data
  );
};

export default editCertificate;
